export enum WorkspaceEventType {
    Login,
    LogOff,
    SpaceAfterData,
    Resize,
    RangeButton,
    QuoteTabActiveMode,
    QuoteFilterTabActiveMode,
    MonitorPeriod,
    LayoutDisplayMode,
    GlobalGridMode,
    DragAndDropSymbol,
    ChartOpenMode,
    ChartLayoutMode,
    ChartInstanceSelect,
    ChartInstanceUnselect,
    BoxOpenMode
}
